"use client";

import { useEffect } from "react";
import { GlassStatusCard } from "@/components/ui/glass-status-card";
import { reportErrorBoundary } from "@/lib/sentry-error-boundary";
interface ErrorBoundaryProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
const isPostHogEnabled = Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY) && (process.env.NEXT_PUBLIC_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV) === "production";
export default function Error({
  error,
  reset
}: ErrorBoundaryProps) {
  useEffect(() => {
    console.error("Application error boundary caught:", error);
    reportErrorBoundary(error, "application", {
      digest: error.digest
    });
    void (async () => {
      if (!isPostHogEnabled) {
        return;
      }
      try {
        const posthog = (await import("posthog-js")).default;
        posthog?.capture?.("app_error_boundary", {
          digest: error.digest ?? null,
          message: error.message
        });
      } catch {
        // Avoid cascading failures from telemetry in the error boundary.
      }
    })();
  }, [error]);
  return <GlassStatusCard hardNavigate eyebrow="Application error" title="Something went wrong" description="An unexpected error occurred while rendering this page." devDetail={process.env.NODE_ENV === "development" ? error.message : undefined} actions={[{
    label: "Try again",
    onClick: reset,
    variant: "primary"
  }, {
    label: "Go home",
    href: "/",
    variant: "secondary"
  }]} data-sentry-element="GlassStatusCard" data-sentry-component="Error" data-sentry-source-file="error.tsx" />;
}